import WebMap from '@arcgis/core/WebMap'

const state = {
  webMap: null
}

const mutations = {
  SET_WEBMAP(state, webMap) {
    state.webMap = webMap
  }
}

const actions = {
  initializeWebMap({ commit }) {
    if (state.webMap) {
      console.log('MAP STATE', state.webMap)
      console.log('WebMap already initialized')
      return
    }
    console.log('Initializing WebMap...') // Debugging
    const webMap = new WebMap({
      portalItem: {
        id: process.env.VUE_APP_WEBMAP_ID
      }
    })
    commit('SET_WEBMAP', webMap)
  }
}

const getters = {
  getWebMap: (state) => state.webMap
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
